import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ListResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

type FetchAllGroupsPayload = {
    ids: number[];
    userEmail: string;
};
export async function fetchAllGroups(payload?: Partial<FetchAllGroupsPayload>) {
    try {
        const endpoint = await RouteService.getGroupsRoute();
        const { data } = await HttpService.get<string, AxiosResponse<ListResponse<API.Group>>>(endpoint + "all", {
            data: "",
            headers: { "content-type": "application/json" },
            params: payload,
        });
        return data.list;
    } catch (error) {
        throw unpackError(error);
    }
}
